import { memo } from 'react';
import type { Key, Translation } from '@/lib/api';
import { cn } from '@/lib/utils';
import { rowStatus, STATUS_LABEL, STATUS_TONE } from './translatorEditorState';

interface Props {
  k: Key;
  translation: Translation | undefined;
  selected: boolean;
  dirty: boolean;
  onSelect: (id: string) => void;
}

function KeyListItemImpl({ k, translation, selected, dirty, onSelect }: Props) {
  const status = rowStatus(translation);
  return (
    <li>
      <button
        type="button"
        onClick={() => onSelect(k.id)}
        aria-current={selected}
        className={cn(
          'group flex w-full flex-col gap-1 border-l-2 px-3 py-2 text-left transition-colors',
          selected
            ? 'border-primary bg-primary/5'
            : 'border-transparent hover:bg-muted/50',
        )}
      >
        <div className="flex items-center gap-2">
          <span className="truncate font-mono text-[11px] text-muted-foreground">
            {k.namespace ? `${k.namespace}/` : ''}
            {k.key}
          </span>
          <span
            className={cn(
              'ml-auto inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-medium leading-none',
              STATUS_TONE[status],
            )}
          >
            {STATUS_LABEL[status]}
          </span>
        </div>
        <p className="truncate text-xs text-foreground">{k.sourceText}</p>
        {translation?.value && (
          <p className="truncate text-xs text-muted-foreground">{translation.value}</p>
        )}
        {dirty && (
          <span
            className="self-start rounded-full bg-warning/15 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-warning"
            aria-label="Unsaved changes"
          >
            Unsaved
          </span>
        )}
      </button>
    </li>
  );
}

export const KeyListItem = memo(KeyListItemImpl);
